import { useIntl } from 'react-intl';

type Params = {
  ariaLabel?: string;
  redirectsToThirdPartyUrl: boolean;
  target: '_blank' | '_self';
};

export const useAriaLabel = ({
  ariaLabel,
  redirectsToThirdPartyUrl,
  target,
}: Params): string | undefined => {
  const { formatMessage } = useIntl();

  if (target !== '_blank') {
    return ariaLabel;
  }

  const id = redirectsToThirdPartyUrl
    ? 'JOBS_JOB_TEASER_LINK_EXTERNAL_NEW_TAB_A11Y'
    : 'JOBS_JOB_TEASER_LINK_NEW_TAB_A11Y';
  return `${ariaLabel}. ${formatMessage({ id })}`;
};
